export default __webpack_public_path__ + "static/ventilator_b.2c3fa9cf4a072c0f1b916d1980e0a29c.svg";